var Marionette = require('marionette');


var TEST_DERIVED_COORDINATES = 0;
if ( PRODUCTION ) {
    TEST_DERIVED_COORDINATES = 0;
}


module.exports = Marionette.ItemView.extend({

    tagName: 'span',

    className: 'ocr_word',

    template: false,

    // this is prob small, can put on template instead ?
    // faster in template/not?
    onRender: function() {

        var model = this.model,
            word = this.model.getWord();

        // TODO: may not even need to print all these -- have a debug mode -- and be able to print from derived if desired?

        this.el.id = 'word_' + model.get('id'); // note the is the original, 'not the derived'
        this.el.setAttribute( 'data-page-key', model.get('page_level_key') );
        this.el.setAttribute( 'data-page-zone', model.get('pageLevelZoneId') );
        this.el.setAttribute( 'data-page-line', model.get('pageLevelLineId') );
        this.el.setAttribute( 'data-page-word', model.get('page_level_id') );

        // maybe store dpi on the model / parse on init
        this.el.setAttribute( 'style',  this.getStyle( model, word ) );

        // with white-space 'pre': allows to copy spaces (can't be nowrap) and text only wrap on line breaks
        // this can help to also test with browser find .. can copy but still can 'find' -- prob absolute positioning ..
        // TODO: maybe only in debug???
        // https://stackoverflow.com/questions/62381455/how-do-i-make-my-html-searchable-by-a-browser-ctrl-f-and-use-absolute-text-posit
        // -- would need to stop with layers and absolute positioning -- more calc's necessary --
        // position within line and zone ...
        // could just test search by removal of abs position
        this.el.innerHTML = (word += ' ');

        //this.el.innerHTML = word;

    },

    getStyle: function( model, word )
    {
        var style = model.getBoxCssStyle( TEST_DERIVED_COORDINATES );

        style += this.getFontStyle(
            !TEST_DERIVED_COORDINATES
                ? model.getBoxPx()
                : model.getBoxPxDerived(), // TODO: box derived logic not correct but only for debug
            word,
            this.options.spacer
        );

        return style;

    },

   getFontStyle: function( box, word, spacer ) {

        var containerWidth = box.getWidth();
        var containerHeight = box.getHeight();

        spacer.style['font-size'] = containerHeight + 'px'; // need to calc based off 100% height
        spacer.innerHTML = word;

        var actualWidth = spacer.clientWidth;

        var widthScale = containerWidth / actualWidth;
        var fontSize = Math.floor( widthScale * containerHeight );

        var style = 'line-height:' + containerHeight + 'px;'; // 'center vertical alignment' -- could make a bit smaller
        style += 'font-size:' + fontSize + 'px;';

        return style;

    }


});

//



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/textLayer/wordLayer/word.js
 ** module id = 447
 ** module chunks = 0
 **/